import React from 'react'
import { useIntl } from 'react-intl'
import { Box, Container, Typography } from '@mui/material';
import { withStyles } from '@mui/styles'
import { CollaboratorsTable } from '../table'
import { CollaboratorsFilter } from '../filter'
import { collaboratorsDashboardStyles } from './collaborators-dashboard.styles'
import { useURLLoader } from '../../../loader/hooks'
import { useCollaboratorsCalls } from '../../../collaborators/hooks'

export const CollaboratorsDashboard = withStyles(collaboratorsDashboardStyles)(({ classes }) => {
  const { formatMessage } = useIntl()
  const { getCollaborators } = useCollaboratorsCalls()
  useURLLoader({
    identifier: 'collaborators',
    defaultChoices: { _pagina: 1, _num_x_pagina: 5 },
    call: getCollaborators,
    minRefreshMs: 1000 * 60,
  })
  return (
    <Box>
      <Container className={classes.container} maxWidth="false">
        <Box mb={2}>
          <Typography variant="h4" color="textSecondary">
            {formatMessage({ id: 'pages.collaborators.title' })}
          </Typography>
        </Box>
        <Box mb={2}>{<CollaboratorsFilter />}</Box>
        <Box>
          <CollaboratorsTable />
        </Box>
      </Container>
    </Box>
  )
})
